module.exports = __webpack_public_path__ + "img/rss-jobmule.29f65877.png";